$('.download-language-modal').on('click', function (e) {
    e.preventDefault();

    let link_de = $(this).attr('downloadlink-de');
    let link_en = $(this).attr('downloadlink-en');
    let link_fr = $(this).attr('downloadlink-fr');
    let link_nl = $(this).attr('downloadlink-nl');
    let link_ro = $(this).attr('downloadlink-ro');
    let link_se = $(this).attr('downloadlink-se');
    let link_cz = $(this).attr('downloadlink-cz');
    let link_sr = $(this).attr('downloadlink-sr')

    let confirmationModal = $('#download-language-modal');

    confirmationModal.find('.download-anchor-de').attr('href', link_de);
    confirmationModal.find('.download-anchor-en').attr('href', link_en);
    confirmationModal.find('.download-anchor-fr').attr('href', link_fr);
    confirmationModal.find('.download-anchor-nl').attr('href', link_nl);
    confirmationModal.find('.download-anchor-ro').attr('href', link_ro);
    confirmationModal.find('.download-anchor-se').attr('href', link_se);
    confirmationModal.find('.download-anchor-cz').attr('href', link_cz);
    confirmationModal.find('.download-anchor-sr').attr('href', link_sr);

    confirmationModal.modal('show');
});
